export default {
  Sign_In: {
    popup_text1: "مرحبا بكم في",
    popup_text2: "الرجاء التسجيل للتمكن من الإنتفاع بالخدمة",
    cinField: "بطاقة التعريف",
    passWordField: "كلمة السر",
    submitField: "ارسل",
    noAcc: "ليس لديك حساب ؟ ",
    noPass: "نسيت كلمة السر؟",
    makeAccount: "إبدء حساب جديد الآن "
  },
  Reset: {
    popup_text2: "الرجاء تغيير كلمة السر في الاستمارة التالية",
    cinField: "بطاقة التعريف",
    oldPasswordField: "كلمة السر القديمة",
    newPasswordField: "كلمة السر الجديدة",
    confirmNewPasswordField: "أثبت كلمة السر الجديدة",
    submitField: "ارسل",
    forgotPass: "ليس لديك حساب ؟ ",
    makeAccount: "إبدء حساب جديد الآن "
  },
  ResetEmail: {
    popup_text2: "الرجاء تعمير البريد الالكتروني",
    emailField: "البريد الالكتروني",
    oldPasswordField: "كلمة السر القديمة",
    newPasswordField: "كلمة السر الجديدة",
    confirmNewPasswordField: "أثبت كلمة السر الجديدة",
    submitField: "ارسل",
    forgotPass: "ليس لديك حساب ؟ ",
    makeAccount: "إبدء حساب جديد الآن "
  },
  HeaderMenu: {
    Userwelcome: "مرحبا ",
    homePage: "الصّفحة الرّئيسيّة",
    liveMap: "خريطة",
    demande: "تعمير مطلب ",
    infoPage: "ارشادات ",
    faq: "اسئلة متداولة",
    signup: "تسجيل",
    loginButton: "دخول",
    logOutButton: "خروج",
    userDashboardButton: "الصفحة الخاصة",
    adminDashboardButton: "لوحة القيادة"
  },
  Sign_Up: {
    popup_text1: "مرحبا بكم في",
    popup_text2: "الرجاء التسجيل للتمكن من الإنتفاع بالخدمة",
    cinField: "بطاقة التعريف",
    nameField: "الاسم و اللقب",
    cityField: "ولاية السكن",
    areaField: "منطقة السكن",
    phoneField: "رقم الهاتف",
    emailField: "البريد الالكتروني",
    passWordField: "كلمة السر",
    submitField: "ارسل",
    forgotPass: "ليس لديك حساب ؟ ",
    makeAccount: "إبدء حساب جديد الآن ",
    text_photo: "صحتك تهمنا"
  },
  HomePageBanner: {
    title1: "الapplication اللي تنظّملك خروجك و تبعّدك على الزحمة ",
    title2: "شوف الخريطة و عمر الفرمولار توا",
    btn1: "شوف الخريطة",
    btn2: "عمّر طلب خروج"
  },
  Steps: {
    intro: "كفاش نجم ننتفع بل خدمة ؟",
    step1: {
      Title: "خطوة 1",
      subTitle: "أعمل حساب"
    },
    step2: {
      Title: "خطوة 2",
      subTitle: "شوف الخريطة"
    },
    step3: {
      Title: "خطوة 3",
      subTitle: "عمّر طلب خروج"
    }
  }
};
